















































import * as def from "@/definitions"

import { Component, Prop, Vue } from "vue-property-decorator";

import { Template } from "@/data/template/template";
import { ImageHelper } from "@/helper/imageHelper"

import { Const } from "@/const"
import { CreatePostParamHelper } from "@/helper/createPostParamHelper"

import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";
import TemplateView from "../templateView/templateView.vue";
// import TemplateViewColored from "./templateViewColored/templateViewColored.vue";

// ボタン
import CheckOn from "../resources/checkOn.vue";
import ValueDown from "../resources/valueDown.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
    DropdownList,
    TemplateView,
    // TemplateViewColored,
    CheckOn,
    ValueDown
  }
})
export default class SelectTemplateColor extends Vue {
  @Prop()
  private selectedTemplate!: Template;

  private isRotateTypeDropdownActive = false;

  transparentImage = ""
  colorVariations : string[] = ["" , "#FEE0E0" , "#FFDBB8" , "#FCF7AB" , "#D6FFA9" , "#D0F8FF" , "#D1E5FA" , "#DFCFEA" , "#E1E1E1"]


  mounted(){
    //this.createTransparentImage()
  }

  createTransparentImage(){

    // let imageInfo = {
    //   "path" : this.src
    // }

    // const XHR = new XMLHttpRequest();

    // XHR.onload = () => {
    //   this.onLoadImage(JSON.parse(XHR.response).data.base64Image)
    // }

    // const query = Const.API_URL_BASE + `path_to_base64.php`

    // XHR.open( 'POST', query );
    // XHR.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' );
    // XHR.send(CreatePostParamHelper.createPostParam(imageInfo));

  }



  private onLoadImage(src)
  {
      // 白色透明化を使う
      ImageHelper.createWhiteTransparentImage(src ,  (image) =>
      {
        this.transparentImage = image;
      });
  }

  get src(): string {
    return "";//"http://label.entap.xyz/template_image/" + this.selectedTemplate.id + ".png";
  }

  get rootData() : def.Data{
    return this.$store.getters.data
  }

  private onClickFixed()
  {
    this.$store.getters.data.isTemplateFixed = !this.$store.getters.data.isTemplateFixed
  }

  private get rotateTypeText() {
    var text = "";
    if (this.rootData.designDirection == 0) {
      text = "編集面を回転しない";
    } else if (this.rootData.designDirection == 1) {
      text = "編集面を90°回転";
    } else if (this.rootData.designDirection == 2) {
      text = "編集面を180°回転";
    } else if (this.rootData.designDirection == 3) {
      text = "編集面を270°回転";
    }
    return text;
  }

  private get rotateTypeDropdownItems() {
    var items = new Array();
    items.push({
      id: 0,
      label: "編集面を回転しない",
      isSelected: this.rootData.designDirection == 0
    });
    items.push({
      id: 1,
      label: "編集面を90°回転",
      isSelected: this.rootData.designDirection == 1
    });
    items.push({
      id: 2,
      label: "編集面を180°回転",
      isSelected: this.rootData.designDirection == 2
    });
    items.push({
      id: 3,
      label: "編集面を270°回転",
      isSelected: this.rootData.designDirection == 3
    });
    return items;
  }

  private onClickRotateType() {
    this.isRotateTypeDropdownActive = true;
  }

  onSelectRotateType(rotateType) {
    this.isRotateTypeDropdownActive = false;
    this.rootData.designDirection = rotateType
  }

  clickDecision()
  {
    var rotate = 0;
    if(this.rootData.designDirection == 1) { rotate = 90; }
    else if(this.rootData.designDirection == 2) { rotate = 180; }
    else if(this.rootData.designDirection == 3) { rotate = 270; }
    this.$emit("ok", this.rootData.isTemplateFixed, rotate);
  }


    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
    private get userConfigBorderBottomColor(){
        var style = {
            borderBottom : "solid 1px " + this.userConfigColor
        };
        return style;
    }

  getResource(file : string){
        return ResourceHelper.getResource(file)
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

}
